<template>
  <div v-if="!logado"></div>
  <div v-else class="container">
    <h1></h1>
    <div class="row">
      <!-- Pessoal -->
      <div class="col-sm-8 text-left">
        Olá {{ this.$root.nome }}!
        <template v-if="smart.agenda">
        <div class="col-sm-12">
          <h3>Sua agenda hoje...</h3>
        </div>
        <div class="labels">
          <div v-for="compromisso in smart.agenda" class="col-sm-4">
            <a @click.prevent="select4agenda(compromisso.cod)" class="glyphicon glyphicon-book"></a>
            <small>
              <cite>{{ compromisso.razao.substring(0,22) }}...</cite>
              <span class="label label-default">{{ compromisso.fantasia.substring(0,25) }}</span> 
              <b>{{ compromisso.hora }} - {{ compromisso.endcidade!==''? compromisso.endcidade : compromisso.cobcidade}}</b>
            </small>
          </div>
        </div>
        </template>
        <template v-if="smart.tarefas">
        <div class="col-sm-12">
          <h3>Suas Tarefas...</h3>
        </div>
        <div class="labels">
          <div v-for="tarefa in smart.tarefas" class="col-sm-4">
            <a @click.prevent="select4tarefa(tarefa.cod)" class="glyphicon glyphicon-flag"></a>
            <cite>{{ tarefa.razao.substring(0,22) }}...</cite>
            <span v-if="tarefa.flagdescr==='Normal' "class="label label-default">{{ tarefa.fantasia.substring(0,25) }}</span>
            <span v-else-if="tarefa.flagdescr==='Moderado'" class="label label-warning">{{ tarefa.fantasia.substring(0,25) }}</span>
            <span v-else class="label label-danger">{{ tarefa.fantasia.substring(0,25) }}</span>
            Prazo {{tarefa.dt_limite}}
          </div>
        </div>
        </template>
      </div>
      <div class="col-sm-4 text-left">
        <h3>Downloads</h3>
        <a href="https://www.google.com/intl/pt-BR_ALL/drive/" target="_blank">Google Drive - Backups</a>
        <p><i class="glyphicon glyphicon-user"></i>  ps2000r@gmail.com</p>
        <p><i class="glyphicon glyphicon-lock"></i>  2010201032263923</p>
        <a href="https://www.google.com/intl/pt-BR_ALL/drive/" target="_blank">Google Drive - Instaladores</a>
        <p><i class="glyphicon glyphicon-user"></i>  psrepos@gmail.com</p>
        <p><i class="glyphicon glyphicon-lock"></i>  ps32263923</p>
        <a href="ftp://ps2000.ddns.com.br:2100" target="_blank">FTP - ftp://ps2000.ddns.com.br:2100</a>
        <p><i class="glyphicon glyphicon-user"></i>  suporte</p>
        <p><i class="glyphicon glyphicon-lock"></i>  suporte</p>
        <a href="http://psconsultoria.com.br" target="_blank">Site PS</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      logado: false,
      smart: {
        agenda: false,
        tarefas: false
      }
    }
  },
  methods: {
    loadSmartAgenda (params = '') {
      const url = './api/php/getagenda.php'
      this.$http.post(url, JSON.stringify({'codfuncionario': this.$root.cod})).then(
        function (response) {
          console.log(response.body)
          if (response.body.status) {
            this.smart.agenda = response.body.rows
          }
        },
        function (error) {
          console.log(error)
        }
      )
    },
    loadSmartTarefas (params = '') {
      const url = './api/php/gettarefa.php'
      this.$http.post(url, JSON.stringify(params)).then(
        function (response) {
          console.log(response.body)
          if (response.body.length > 0) {
            this.smart.tarefas = response.body
          }
        },
        function (error) {
          console.log(error)
        }
      )
    },
    select4tarefa (cod) {
      this.$router.push({path: `/tarefa/u/${cod}`})
    },
    select4agenda (cod) {
      this.$router.push({path: `/agenda/u/${cod}`})
    }
  },
  created: function () {
    this.logado = this.$root.auth
    this.loadSmartAgenda()
    // Conf busca de tarefas
    let filters = {}
    filters.flag = '*'
    filters.coduser = this.$root.cod
    filters.situacao = '2'
    filters.dtmin = '1900-01-01 00:00:00'
    filters.dtmax = '9999-12-31 23:59:59'
    this.loadSmartTarefas({'filters': filters})
  }
}
</script>

<style scoped>
  div.col-sm-4.text-left a {
    display:block;
  }
  h1, h2, h3 {
    
  }
  div p {
    color: #333;
    font-size: 12px;
  }
  .label {
    padding: 5px;
    display: block;
  }
  .labels div.col-sm-4 {
    border-bottom: 1px dashed #ccc;
    padding-bottom: 10px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue